<template>
    <div id="app">
        <Navigation />
        <b-container class="py-5 pt-sm-0" style="min-height: 600px">
            <b-row>
                <Breadcrumbs v-if="false"></Breadcrumbs> <!-- change to true for turn on -->
                <Toats ref="requestToats"></Toats>
                <router-view>
                </router-view>
            </b-row>
        </b-container>
        <Footer />
        <go-top :size="50" :right="10" bg-color="#006784" :bottom="10" style="border: 1px solid white; border-radius:50%;"></go-top>
    </div>
</template>

<script>
    import Navigation from "components/Navigation.vue";
    import Footer from "./components/Footer.vue";
    import GoTop from '@inotom/vue-go-top';

    export default {
        name: 'app',
        data() {
            return {
                registration: null,
            };
        },
        components: {
            Footer,
            Navigation,
            GoTop
        },
        mounted() {
            document.addEventListener('swUpdated', this.showRefreshUI);
            document.addEventListener('swOffline', this.showRefreshUI);
        },
        beforeDestroy() {
            document.removeEventListener('swUpdated', this.showRefreshUI);
            document.removeEventListener('swOffline', this.showRefreshUI);
        },
        methods: {
            showRefreshUI(e) {
                this.registration = e.detail;
                if (e.detail === 'OfflineMode')
                    this.$refs.requestToats.makeToast('warning', 'no internet connection', 'You are using app in offline mode');
            }
        },
    };
</script>

<style>
</style>

